import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import VendorHeader from "../component/VendorHeader";
import VendorFooter from "../component/VendorFooter";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";
import { NotificationManager } from "react-notifications";

const ContactFormDetails = () => {
    const { user } = useAuth();
    const { langJson } = useLanguage();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);

    const listPath = user?.role === "vendor" ? "/contact-forms" : "/admin/contact-forms";

    const fetchDetails = async () => {
        setLoading(true);
        try {

            const response = await fetch(`${API_BASE_URL}stores/contact-forms/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user?.authorisation?.token}`,
                },
            });

            const responseData = await response.json();
            if (response.ok && responseData?.res) {
                setDetails(responseData?.data || null);
            } else {
                NotificationManager.warning(responseData?.msg || "Failed to fetch contact form details");
            }
        } catch (error) {
            NotificationManager.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [id]);

    return (
        <div>
            <div className="dashHeader">
                <VendorHeader />
            </div>
            <div className="adminDash">
                <Sidebar />
                <div className="rightSide">
                    <h2>{langJson?.contactforms ?? "Contact Forms"}</h2>

                    <div className="addProductForm">
                        <ul className="addAddress">
                            {loading && (
                                <li className="fullWidth">
                                    <label>Loading...</label>
                                </li>
                            )}

                            {!loading && (
                                <>
                                    <li>
                                        <label>{langJson?.company || "Company name"}</label>
                                        <p>{details?.company_name || "-"}</p>
                                    </li>
                                    <li>
                                        <label>{langJson?.name ?? "Name"}</label>
                                        <p>{details?.name || "-"}</p>
                                    </li>
                                    <li>
                                        <label>{langJson?.email ?? "Email"}</label>
                                        <p>{details?.email || "-"}</p>
                                    </li>
                                    <li>
                                        <label>{langJson?.phone ?? "Phone"}</label>
                                        <p>{details?.phone || "-"}</p>
                                    </li>
                                    <li className="fullWidth">
                                        <label>{langJson?.message ?? "Message"}</label>
                                        <p>{details?.message || "-"}</p>
                                    </li>
                                    <li>
                                        <label>{langJson?.createdat ?? "Received At"}</label>
                                        <p>{details?.created_at_human || details?.created_at || "-"}</p>
                                    </li>
                                    <li>
                                        <label>{langJson?.readat ?? "Read At"}</label>
                                        <p>{details?.read_at_human || details?.read_at || "-"}</p>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>

                    <div className="fullWidth saveBtn addAddress">
                        <Link className="backLink" to={listPath}>{langJson?.back ?? "Back"}</Link>
                    </div>
                </div>
            </div>
            <VendorFooter />
        </div>
    );
};

export default ContactFormDetails;
